import { render, staticRenderFns } from "./ParlayInfoPremium.vue?vue&type=template&id=184daee8&scoped=true&"
import script from "./ParlayInfoPremium.vue?vue&type=script&lang=js&"
export * from "./ParlayInfoPremium.vue?vue&type=script&lang=js&"
import style0 from "./ParlayInfoPremium.vue?vue&type=style&index=0&id=184daee8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184daee8",
  null
  
)

export default component.exports